import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];

    if (!sessionId) { navigate("/login"); return; }

    (async () => {
      try {
        // Use authApi so the Set-Cookie response actually persists the session cookie.
        const res = await authApi.post("/auth/oauth/session", { session_id: sessionId });
        setUser(res.data.user);
        // strip the hash and go to right destination
        window.history.replaceState({}, "", window.location.pathname);
        const dest = res.data.user.role === "admin" ? "/admin" : "/dashboard";
        navigate(dest, { state: { user: res.data.user }, replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#1C3326] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#5C635A] font-light">Completing sign in...</p>
      </div>
    </div>
  );
}
